import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService, LoansService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';  

@Component({
  selector: 'app-excesspayment',
  templateUrl: './excesspayment.component.html',
  styleUrls: ['./excesspayment.component.css']
})
export class ExcesspaymentComponent implements OnInit {

  loading = false;
  start_date = '2022-07-20';
  end_date = '2022-07-21';
  customers:any;
  currentUser:any;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService, public loansService: LoansService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getExcessPayments();
  }
  getExcessPayments() {

    this.loading = true;
    this.loansService.getExcessPayments(this.currentUser.token)
      .subscribe(employee_performance => {
        this.loading = false;
        this.customers = employee_performance
      });

  }
  openRequest(REQUEST_ID){
    this.DataService.loadPortfolioFromExcessRepayment.emit({REQUEST_ID:REQUEST_ID})
  }
  // isItCCs(customerEmail){
  //   this.loading = true;
  //   this.loansService.isItCCs(customerEmail, this.currentUser.token)
  //     .subscribe(result => {
  //       return result;
  //     });
  // }
}
